import GoodDesignAwardFrame from "./components/GoodDesignAwardFrame";
import GoodDesignAwardForm from "./components/GoodDesignAwardForm";
import UserAccountRoutes from "../front_user_account/routes";

export default [
    {
        path: "/good-design-award",
        name: "good-design-award",
        redirect: "/good-design-award/account",
        meta: {
            auth: true,
            basePath: true,
            award: "gooddesign",
            awardName: "Good Design Award",
        },
        component: GoodDesignAwardFrame,
        children: [
            {
                path: "",
                component: GoodDesignAwardForm,
                name: "good-design-award-form",
            },
            ...UserAccountRoutes,
        ],
    },

    /*/future-house-awards*/
];
